export default __webpack_public_path__ + "static/media/01Bhopal.a7f26d13.jpg";